import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import {Descriptions, Divider, Tag} from 'antd';
import {FcCheckmark} from 'react-icons/all';
import {OrganizationContext} from '../OrganizationContext';

import {addressText} from 'utils/Utils';

const OrganizationInfo = () => {
  const intl = useIntl();

  const organizationContext = useContext(OrganizationContext);
  const {selectedOrganization} = organizationContext;

  return (
    <>
      <Descriptions
        bordered
        title={selectedOrganization?.name}
        size='middle'
        style={{paddingTop: 10}}>
        <Descriptions.Item label={intl.messages['organization.name']}>
          {selectedOrganization?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.enabled']}>
          {selectedOrganization?.active ? <FcCheckmark /> : <></>}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['organization.partOf']}>
          {selectedOrganization?.partOf?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['organization.type']} span={3}>
          {selectedOrganization?.types.map((type) => (
            <Tag color='blue' key={type}>
              {intl.messages[`organization.type.${type.toLowerCase()}`]}
            </Tag>
          ))}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.phoneNumber']}>
          {selectedOrganization?.phone}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.email']}>
          {selectedOrganization?.email}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['organization.website']}>
          {selectedOrganization?.website}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['address']}>
          {addressText(selectedOrganization?.address)}
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      <Descriptions
        bordered
        title={intl.messages['contact']}
        size='middle'
        style={{paddingTop: 10, paddingBottom: 10}}>
        <Descriptions.Item label={intl.messages['contact.name']}>
          {selectedOrganization?.contact?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.phoneNumber']}>
          {selectedOrganization?.contact?.phone}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.email']}>
          {selectedOrganization?.contact?.email}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['address']}>
          {addressText(selectedOrganization?.contact?.address)}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default OrganizationInfo;
